/**
 *@description Adds spaces between title-case words 
 * (e.g., "ProposalResourceAccess" → "Proposal Resource Access").
 * Handles acronyms like "APIKey" → "API Key".
 * @param input - The title-case string to add spaces to.
 * @returns The input string with spaces added between title-case words.
 */
export function addSpacesToTitleCase(input: string): string {
  return input
    .replaceAll(/([a-z])([A-Z])/g, "$1 $2")        // camelCase → space before capital
    .replaceAll(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")  // Handle acronyms: APIKey → API Key
    .trim();
}
